import {
  DollhouseIcon,
  FaroTooltip,
  LayoutSheetSmallIcon,
  ToolButton,
  ToolGroup,
} from "@faro-lotv/flat-ui";
import { OverlayToolbar } from "@/components/ui/overlay-toolbar";
import { MouseEvent, useCallback, type JSX } from "react";

export enum Projection {
  /** 2 dimensional Projection*/
  twoDimensional = "2D",

  /** 3 dimensional projection */
  threeDimensional = "3D",
}

type ProjectionSwitchProps = {
  /** The currently active projection. */
  projection: Projection;

  /** A callback to execute when the user changes the projection. */
  onProjectionChange(projection: Projection): void;
};

/** @returns A toolbar to change the projection method. */
export function ProjectionSwitch({
  projection,
  onProjectionChange,
}: ProjectionSwitchProps): JSX.Element {
  const changeProjection = useCallback(
    (_event: MouseEvent, value: Projection | null) => {
      if (value) {
        onProjectionChange(value);
      }
    },
    [onProjectionChange],
  );

  return (
    <OverlayToolbar>
      <ToolGroup
        value={projection}
        orientation="vertical"
        exclusive
        onChange={changeProjection}
      >
        <FaroTooltip
          key="projection-3d-overview"
          title="3D overview"
          placement="right"
        >
          <ToolButton
            aria-label="point clouds in 3d projection"
            value={Projection.threeDimensional}
            selected={projection === Projection.threeDimensional}
          >
            <DollhouseIcon />
          </ToolButton>
        </FaroTooltip>
        <FaroTooltip
          key="projection-2d-overview"
          title="2D overview"
          placement="right"
        >
          <ToolButton
            aria-label="point clouds in 2d projection"
            value={Projection.twoDimensional}
            selected={projection === Projection.twoDimensional}
          >
            <LayoutSheetSmallIcon />
          </ToolButton>
        </FaroTooltip>
      </ToolGroup>
    </OverlayToolbar>
  );
}
